type SeoInputData = {
  seoData?: SeoDataType;
  fallBackSeoData: SeoDataType;
};

type SeoDataType = {
  title?: string;
  description?: string;
  image?: string;
  siteName?: string;
  keywords?: string;
  canonicalUrl?: string;
};

export const useCustomSeoMeta = (data: SeoInputData) => {
  const { seoData, fallBackSeoData } = data;

  const title = seoData?.title || fallBackSeoData.title || undefined;

  const description =
    seoData?.description || fallBackSeoData.description || undefined;

  const image = seoData?.image || fallBackSeoData.image || undefined;

  const siteName = seoData?.siteName || fallBackSeoData.siteName || undefined;

  const keywords = seoData?.keywords || fallBackSeoData.keywords || undefined;

  const canonicalUrl =
    seoData?.canonicalUrl || fallBackSeoData.canonicalUrl || undefined;

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description,
    ogImage: image,
    ogSiteName: siteName,
    ogUrl: canonicalUrl,
    keywords: keywords,
  });

  if (canonicalUrl) {
    useHead(() => ({
      link: [
        {
          rel: 'canonical',
          href: canonicalUrl,
        },
      ],
    }));
  }
};
